import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { DetailsModel } from '@core/components/ui-clinng-status-alert/ui-clinng-status-alert.component';
import type { TicketDetails } from '@core/components/ui-clinng-ticket-info/ui-clinng-ticket-info.component';
import { UiClinngStaticHeaderComponent } from '@core/components/ui-clinng-static-header/ui-clinng-static-header.component';
import { UiClinngStatusAlertComponent } from '@core/components/ui-clinng-status-alert/ui-clinng-status-alert.component';
import { UiClinngTicketInfoComponent } from '@core/components/ui-clinng-ticket-info/ui-clinng-ticket-info.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'download-pse-voucher',
  standalone: true,
  imports: [CommonModule, UiClinngTicketInfoComponent,
    UiClinngStatusAlertComponent,
    MatToolbarModule,
    MatIconModule,
    UiClinngStaticHeaderComponent
  ],
  templateUrl: './download-pse-voucher.component.html',
  styleUrl: './download-pse-voucher.component.scss',
})
export class DownloadPseVoucherComponent {
  @Input() detailsModel!: DetailsModel;
  @Input() operationInfo!: any;
  @Input() ticketDetails: TicketDetails[] = [];
}
